import {deviceGroupConstants} from "../constants/device-group.constants";

const initState = {
    list: null,
    dropdown: null,
    singleItem: null,
};

export function deviceGroupReducer(state = initState, action) {
    switch (action.type) {
        case deviceGroupConstants.DEVICE_GROUP_LIST_REQUEST:
        case deviceGroupConstants.DEVICE_GROUP_DROPDOWN_REQUEST:
        case deviceGroupConstants.DEVICE_GROUP_LIST_FAILURE:
        case deviceGroupConstants.DEVICE_GROUP_CLEAR_LIST:
            return {
                ...state,
                list: null,
                dropdown: null,
                singleItem: null,
            };
        case deviceGroupConstants.DEVICE_GROUP_BY_ID_REQUEST:
            return {
                ...state,
                singleItem: null
            };
        case deviceGroupConstants.DEVICE_GROUP_DROPDOWN_SUCCESS:
            return {
                ...state,
                dropdown: action.dropdown
            };
        case deviceGroupConstants.DEVICE_GROUP_BY_ID_SUCCESS:
            return {
                ...state,
                singleItem: action.deviceGroupModel
            };
        case deviceGroupConstants.DEVICE_GROUP_LIST_SUCCESS:
            return {
                ...state,
                list: action.deviceGroupModel
            };
        default:
            return state
    }
}
